import styled from 'styled-components';

export const HomeContainer = styled.div`
  padding: 0px 10px 10px 10px;
  display: flex;
  flex-direction: column;
  height: 100%;
  align-items: center;

  @media (max-width: 600px) {
    padding: 0px 8px 8px 8px;
  }
`;

export const DashboardContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 16px;
  margin-top: 8px;
  width: 100%;

  @media (max-width: 600px) {
    grid-template-columns: repeat(2, 1fr);
    gap: 8px;
  }
`;

export const SkeletonContainer = styled.div`
  display: flex;
  flex-direction: column;
  border: 1px solid #e5e7eb;
  box-shadow: rgba(60, 64, 67, 0.08) 0px 1px 3px 0px;
  padding: 16px 20px;
  border-radius: 12px;
  min-height: 110px;

  @media (max-width: 600px) {
    padding: 10px 12px;
    min-height: 80px;
    border-radius: 8px;
  }
`;

export const SkeletonChartContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 520px;
  height: 520px;
  padding: 40px;
  border: 1px solid #8d8e8f;
  box-sizing: border-box;

  @media (max-width: 600px) {
    width: 100%;
    height: auto;
    min-height: 300px;
    padding: 20px;
  }
`;

export const DashboardCard = styled.div`
  display: flex;
  flex-direction: column;
  border: 1.5px solid #8d8e8f;
  box-shadow: rgba(60, 64, 67, 0.08) 0px 1px 3px 0px;
  padding: 16px 20px;
  border-radius: 12px;
  min-height: 110px;

  @media (max-width: 600px) {
    padding: 10px 12px;
    min-height: 80px;
    border-radius: 8px;
  }

  > div > span {
    color: #209088;
    font-size: 14px;

    @media (max-width: 600px) {
      font-size: 11px;
    }
  }

  h1 {
    color: #7f8790;
    margin: 8px 0 0;
    font-size: 34px;
    line-height: 1;

    @media (max-width: 600px) {
      font-size: 22px;
      margin: 4px 0 0;
    }
  }

  p {
    margin: 8px 0 0;
    font-size: 20px;
    color: #7f8790;

    @media (max-width: 600px) {
      font-size: 14px;
      margin: 4px 0 0;
    }
  }
`;

export const DashboardCardNR1 = styled.div<{ themeState: { isDark: boolean } }>`
  background: ${props => props.themeState.isDark !== true ? '#ffffff' : '#1E1E1E'};
  border-radius: 12px;
  padding: 28px 24px;
  box-shadow: rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px;
  border: 1px solid #e5e7eb;
  flex: 1;
  max-width: 400px;

  @media (max-width: 600px) {
    padding: 16px 14px;
    border-radius: 8px;
    max-width: 100%;
  }

  h1 {
    font-size: 52px;
    font-weight: 700;
    line-height: 1;
    margin: 0 0 12px 0;
    color: ${props => props.themeState.isDark !== true ? '#7f8790' : '#ffffff'};

    @media (max-width: 600px) {
      font-size: 32px;
      margin: 0 0 8px 0;
    }
  }

  h3 {
    font-size: 16px;
    font-weight: 600;
    line-height: 1.5;
    margin: 0 0 8px 0;
    color: #209088;

    @media (max-width: 600px) {
      font-size: 13px;
      margin: 0 0 6px 0;
    }
  }

  p {
    font-size: 13px;
    line-height: 1.6;
    color: #6b7280;
    margin: 0;

    @media (max-width: 600px) {
      font-size: 11px;
    }
  }
`;


export const Graficos = styled.div`
  display: flex;
  gap: 3rem;
  flex-wrap: wrap;
  justify-content: center;
  max-width: 1400px;
  margin: 0 auto;

  @media (max-width: 600px) {
    gap: 1rem;
  }
`;

export const Grafico = styled.div`
  flex-wrap: wrap;
  display: flex;
  flex-direction: column;
  border-radius: 8px;
  align-items: center;
  justify-content: center;
  margin-top: 1rem;
  box-shadow: rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px;
  padding: 1.25rem;

  @media (max-width: 600px) {
    padding: 0.75rem;
    margin-top: 0.5rem;
    width: 100%;
    max-width: 100%;
  }
  
  h2,
  h3 {
    color: #54586e;

    @media (max-width: 600px) {
      font-size: 14px;
    }
  }
`;

export const UserArea = styled.div`
  width: 100%;
  font-size: 1.6rem;
  padding: 40px;

  @media (max-width: 600px) {
    padding: 16px;
    font-size: 1.2rem;
  }
`;

export const LegendContainer = styled.div`
  max-height: 400px;
  overflow-y: auto;
  padding-right: 8px;
  scrollbar-width: none;
  &::-webkit-scrollbar {
    display: none;
  }

  @media (max-width: 600px) {
    max-height: 250px;
  }
`;
